import { HttpClient, JSON_STRING, MHTTPCL, clientName, baseUrl } from "../../../services/http/http-client";
import { MODIFICATION_URL } from "../../booking/services/booking-service";

export const ACCOUNTING_URL = '/accounting.pl';
export const ACCOUNTING_COST_SECTION = 'costs';
export const LABEL_URL = '/label.pl';
export const LABEL_COMMON_SECTION = 'common';

export const CostsService = {

    findCostData: () => HttpClient.get(ACCOUNTING_URL, {
        section: ACCOUNTING_COST_SECTION,
        action: 'home',
        output: JSON_STRING
    }),

    findAllCosts: (extraParms) => HttpClient.post(ACCOUNTING_URL, {
        section: ACCOUNTING_COST_SECTION,
        action: ACCOUNTING_COST_SECTION,
        output: JSON_STRING,
        ...extraParms
    }),

    searchCosts: ({
        search = "",
        cost_group_id = "",
        invoice_project_id = "",
        status_colors = ""
    }, options) => {
        // It is expected that status_colors is a comma separated string of hex color codes with hash character infront
        status_colors = status_colors.split(',').map(e => e?.length > 0 ? `#${e}` : '').join(',');
        return HttpClient.post(ACCOUNTING_URL, {
            section: ACCOUNTING_COST_SECTION,
            action: 'search_costs',
            search,
            cost_group_id,
            invoice_project_id,
            status_colors
        }, options)
    },
    advance_search: ({
        // start
        // end
        // start_payment
        // end_payment
        // status_textkeys
        // invoice_project_ids
        // subject
        // amount
        // pdf
        // invoice_ref
        // recipient
        row_start = 0,
        start = '',
        end = '',
        start_payment = '',
        end_payment = '',
        status_textkeys = '',
        invoice_project_ids = '',
        cost_group_ids = '',
        subject = '',
        amount = '',
        pdf = '',
        invoice_ref = '',
        recipient = '',
    }, options) => HttpClient.get(ACCOUNTING_URL, {
        section: 'costs',
        action: 'advance_search',
        start,
        end,
        start_payment,
        end_payment,
        status_textkeys,
        invoice_project_ids,
        cost_group_ids,
        subject,
        amount,
        pdf,
        invoice_ref,
        recipient,

        row_start,
    }, options),
    deleteCost: (invoice_id) => HttpClient.post(ACCOUNTING_URL, {
        section: ACCOUNTING_COST_SECTION,
        action: "delete_cost",
        invoice_id,
        output: JSON_STRING
    }),

    findCostAddData: () => HttpClient.post(ACCOUNTING_URL, {
        section: ACCOUNTING_COST_SECTION,
        action: 'cost_form_data',
        output: JSON_STRING
    }),

    searchContactCostAddModal: (search) => HttpClient.post(ACCOUNTING_URL, {
        section: ACCOUNTING_COST_SECTION,
        action: 'search_cost_contacts',
        output: JSON_STRING,
        search
    }),

    addNewCost: (newdata) => HttpClient.post(ACCOUNTING_URL, {
        section: ACCOUNTING_COST_SECTION,
        action: 'new_cost_data',
        output: JSON_STRING,
        ...newdata
    }),

    findCostOverViewTabData: (invoice_id) => HttpClient.post(ACCOUNTING_URL, {
        section: ACCOUNTING_COST_SECTION,
        action: 'cost_overview_data',
        // output: JSON_STRING,
        invoice_id
    }),

    findCostAssignProjects: (invoice_id) => HttpClient.post(ACCOUNTING_URL, {
        section: ACCOUNTING_COST_SECTION,
        action: 'cost_projects_data',
        output: JSON_STRING,
        invoice_id
    }),
    findCostRoyaltyAccounts: (invoice_id) => HttpClient.post(ACCOUNTING_URL, {
        section: ACCOUNTING_COST_SECTION,
        action: 'cost_royalty_data',
        output: JSON_STRING,
        invoice_id
    }),
    invoiceTotalCostSplit: (invoice_id) => HttpClient.post(ACCOUNTING_URL, {
        section: ACCOUNTING_COST_SECTION,
        action: 'invoice_total_cost_split',
        output: JSON_STRING,
        invoice_id
    }),
    createCostSplit: (cost_split_id) => HttpClient.post(LABEL_URL, {
        section: 'common',
        action: 'create_cost_split',
        output: JSON_STRING,
        cost_split_id
    }),
    getCost: (cost_split_id) => HttpClient.post(LABEL_URL, {
        section: 'releases',
        action: 'get_cost',
        output: JSON_STRING,
        cost_split_id
    }),

    update_currency: (invoice_id, currency_id) => HttpClient.post(ACCOUNTING_URL, {
        section: 'costs',
        action: 'update_currency',
        invoice_id,
        currency_id,
    }),


    modify_invoices: (id, columnName, columnNewValue) => {
        HttpClient.modify('invoice_id', id, columnName, columnNewValue, 'invoices');
    },

    modify_invoicelines: (id, columnName, columnNewValue) => {
        HttpClient.modify('invoiceline_id', id, columnName, columnNewValue, 'invoicelines');
    },

    modify_payments: (id, columnName, columnNewValue) => {
        HttpClient.modify('payment_id', id, columnName, columnNewValue, 'payments');
    },

    modify_cost_splits: (id, columnName, columnNewValue) => {
        HttpClient.modify('cost_split_id', id, columnName, columnNewValue, 'cost_splits');
    },

    modify_l_balances: (id, columnName, columnNewValue) => {
        HttpClient.modify('balance_id', id, columnName, columnNewValue, 'l_balances');
    },

    findCostContacts: () => HttpClient.post(ACCOUNTING_URL, {
        section: ACCOUNTING_COST_SECTION,
        action: 'cost_contacts',
        output: JSON_STRING
    }),

    updateCostContact: (invoice_id, contact_id) => HttpClient.post(ACCOUNTING_URL, {
        section: ACCOUNTING_COST_SECTION,
        action: 'update_cost_contact',
        output: JSON_STRING,
        invoice_id,
        contact_id
    }),

    costInvoicelinesAdd: (invoice_id) => HttpClient.post(ACCOUNTING_URL, {
        section: ACCOUNTING_COST_SECTION,
        action: 'add_cost_invoiceline',
        output: JSON_STRING,
        invoice_id
    }),

    costInvoicelinesDelete: (invoice_id, invoiceline_id) => HttpClient.post(ACCOUNTING_URL, {
        section: ACCOUNTING_COST_SECTION,
        action: 'delete_cost_invoiceline',
        output: JSON_STRING,
        invoice_id,
        invoiceline_id
    }),

    updateVatHandling: (invoice_id, vat_handling) => HttpClient.post(ACCOUNTING_URL, {
        section: ACCOUNTING_COST_SECTION,
        action: 'update_vat_handling',
        output: JSON_STRING,
        invoice_id,
        vat_handling
    }),

    findTaxTypes: () => HttpClient.post(ACCOUNTING_URL, {
        section: ACCOUNTING_COST_SECTION,
        action: 'tax_type_list',
        output: JSON_STRING
    }),

    updateInvoiceTaxType: (invoice_id, tax_type_id) => HttpClient.post(ACCOUNTING_URL, {
        section: ACCOUNTING_COST_SECTION,
        action: 'update_invoice_tax_type',
        output: JSON_STRING,
        invoice_id,
        tax_type_id
    }),
    changeTaxDeduction: ({
        invoice_id,
        tax_group_id,
    }) => HttpClient.post(ACCOUNTING_URL, {
        section: 'costs',
        action: 'update_invoice_tax_type',
        invoice_id,
        tax_group_id,
    }),
    costPaymentsAdd: (invoice_id) => HttpClient.post(ACCOUNTING_URL, {
        section: ACCOUNTING_COST_SECTION,
        action: 'add_cost_payment',
        output: JSON_STRING,
        invoice_id
    }),

    costPaymentsDelete: (payment_id) => HttpClient.post(ACCOUNTING_URL, {
        section: ACCOUNTING_COST_SECTION,
        action: 'delete_cost_payment',
        output: JSON_STRING,
        payment_id
    }),

    costSplitsDelete: (cost_split_id) => HttpClient.post(ACCOUNTING_URL, {
        section: ACCOUNTING_COST_SECTION,
        action: 'delete_cost_split',
        cost_split_id
    }),

    costSplitUpdateHoldFlag: (cost_split_id, flag_params) => HttpClient.post(ACCOUNTING_URL, {
        section: ACCOUNTING_COST_SECTION,
        action: 'update_hold_flag',
        cost_split_id,
        ...flag_params
    }),


    findCostAssignProjectRecoupables: (cost_split_id) => HttpClient.post(LABEL_URL, {
        section: LABEL_COMMON_SECTION,
        action: 'cost_split_data',
        output: JSON_STRING,
        cost_split_id
    }),

    searchRoyaltyAccounts: (search) => HttpClient.post(LABEL_URL, {
        section: "royalty",
        action: 'search_accounts',
        output: JSON_STRING,
        search
    }),

    searchRoyaltyContracts: (search) => HttpClient.post(LABEL_URL, {
        section: "royalty",
        action: 'search_contracts',
        output: JSON_STRING,
        search
    }),

    deleteCostBalance: (balance_id) => HttpClient.post(LABEL_URL, {
        section: 'royalty',
        action: 'delete_balance',
        balance_id
    }),

    findBalanceTotalAccounted: (cost_split_id) => HttpClient.post(LABEL_URL, {
        section: LABEL_COMMON_SECTION,
        action: 'total_accounted',
        output: JSON_STRING,
        cost_split_id
    }),

    addNewCostBalance: (cost_split_id) => HttpClient.post(LABEL_URL, {
        section: LABEL_COMMON_SECTION,
        action: 'new_cost_balance',
        cost_split_id,
        output: JSON_STRING
    }),

    updateCostBalanceAmount: (cost_split_id, balance_id, amount) => HttpClient.post(LABEL_URL, {
        section: LABEL_COMMON_SECTION,
        action: 'update_balance_amount',
        cost_split_id,
        balance_id,
        amount,
        output: JSON_STRING
    }),

    fetchCostBalanceDate: (cost_split_id, royalty_account_id, balance_id) => HttpClient.post("/jsonapi.pl", {
        action: 'cost_recoupment_date',
        cost_split_id,
        balance_id,
        royalty_account_id
    }),

    deleteRoyaltyAccountsRecoupables: (balance_id) => HttpClient.post(ACCOUNTING_URL, {
        section: ACCOUNTING_COST_SECTION,
        action: 'delete_balance',
        balance_id
    }),

    costSplitAll: (invoice_id) => HttpClient.post(ACCOUNTING_URL, {
        section: ACCOUNTING_COST_SECTION,
        action: 'cost_split_all',
        invoice_id
    }),

    findCostSplitAddReleases: (invoice_id) => HttpClient.post(ACCOUNTING_URL, {
        section: ACCOUNTING_COST_SECTION,
        action: 'cost_split_releases',
        invoice_id
    }),

    searchCostSplitAddReleases: (search) => HttpClient.post(ACCOUNTING_URL, {
        section: ACCOUNTING_COST_SECTION,
        action: 'search_cost_split_releases',
        search
    }),

    addNewCostSplit: (params) => HttpClient.post(ACCOUNTING_URL, {
        section: ACCOUNTING_COST_SECTION,
        action: 'new_cost_split',
        ...params
    }),

    findCostSplitAddProducts: (invoice_id) => HttpClient.post(ACCOUNTING_URL, {
        section: ACCOUNTING_COST_SECTION,
        action: 'cost_split_products',
        invoice_id
    }),

    searchCostSplitAddProducts: (search) => HttpClient.post(ACCOUNTING_URL, {
        section: ACCOUNTING_COST_SECTION,
        action: 'search_cost_split_products',
        search
    }),

    findCostSplitAddBookings: (invoice_id) => HttpClient.post(ACCOUNTING_URL, {
        section: ACCOUNTING_COST_SECTION,
        action: 'cost_split_booking_data',
        invoice_id
    }),

    searchCostSplitAddBookings: (artist_id, booking_month) => HttpClient.post(ACCOUNTING_URL, {
        section: ACCOUNTING_COST_SECTION,
        action: 'filter_cost_split_booking',
        artist_id,
        booking_month
    }),

    findCostSplitAddTours: (invoice_id) => HttpClient.post(ACCOUNTING_URL, {
        section: ACCOUNTING_COST_SECTION,
        action: 'cost_split_tours',
        invoice_id
    }),

    searchCostSplitAddTours: (search) => HttpClient.post(ACCOUNTING_URL, {
        section: ACCOUNTING_COST_SECTION,
        action: 'search_cost_split_tours',
        search
    }),

    modify: ({ table, kVal, name, value }) => MHTTPCL.post(MODIFICATION_URL, {
        table,
        kVal,
        name,
        value,
        output: JSON_STRING
    }),

}